import React from 'react';

function Senegal(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123996)">
        <mask
          id="mask0_800_123996"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123996)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.25 0H24.75V24H11.25V0Z"
            fill="#FBCD17"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0848 14.4904L14.1635 16.9081L15.4165 12.7671L12.5378 9.97887H16.4357L18.0848 5.88409L19.7339 9.97887H23.6252L20.7531 12.7671L22.1915 16.6637L18.0848 14.4904Z"
            fill="#006923"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.75 0H36V24H24.75V0Z"
            fill="#E11C1B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H11.25V24H0V0Z"
            fill="#006923"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123996">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Senegal;
